var render, staticRenderFns
import script from "./Carousel.js?vue&type=script&lang=js&"
export * from "./Carousel.js?vue&type=script&lang=js&"
import style0 from "./Carousel.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports